import { AreaNotification } from "@relode/core";
import * as React from "react";

import { JobProvider, useJobContext } from "../_infra/jobProvider";
import { JobDetails } from "./job/jobDetails";

export const JobContainer = () => (
    <JobProvider>
        <JobContainerWrapper />
    </JobProvider>
);

const JobContainerWrapper = () => {
    const {
        state: {
            data: { job },
        },
    } = useJobContext();

    return (
        <>
            <AreaNotification areaName="loadJob" />
            {job ? <JobDetails /> : null}
        </>
    );
};
